import { AutoComplete, Form, Input, InputNumber, Select } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useCodigosInfraccionAPI, { CodigoInfraccion } from "../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import useEtiquetas from "../codigos-infraccion/hooks/useEtiquetas";
import DataSave from "../common/components/DataSave";
import MainLayout from "../common/components/MainLayout";
import { ActionResult } from "../common/hooks/useApi";
import useUnidadesProduccionAPI, { UnidadProduccion } from "./useUnidadesProduccionAPI";


export default () => {
    const { id } = useParams();
    const api = useUnidadesProduccionAPI();
    const successRoute = "/unidades-produccion"
    const codigosInfraccionApi = useCodigosInfraccionAPI();

    return (
        <MainLayout title="Guardar unidad de producción">
            <DataSave<UnidadProduccion, UnidadProduccion, UnidadProduccion>
                list={api.list}
                save={api.save}
                transformOnLoad={async (value) => value}
                transformOnSave={async (value) => value}
                id={id}
                successRoute={successRoute}

            >
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Nombre"}
                    label="Nombre">
                    <Input />
                </Form.Item>

            </DataSave>
        </MainLayout>
    );
};